import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../../core/services/api.service';
import { LabelPrintService } from '../../../core/services/label-print.service';
import { PageTitleService } from '../../../core/services/page-title.service';
import { BookFormComponent, BookSavedEvent } from '../book-form/book-form.component';

@Component({
  selector: 'app-add-book',
  standalone: true,
  imports: [CommonModule, FormsModule, BookFormComponent],
  templateUrl: './add-book.component.html',
  styleUrl:    './add-book.component.scss',
})
export class AddBookComponent implements OnInit {

  // Session tracking
  booksAddedCount = 0;
  lastAddedBook   = '';

  // Add Copy modal
  showAddCopyModal      = false;
  addCopyBook:     any  = null;
  addCopyStep: 'form' | 'result' = 'form';
  addCopyCopies         = 1;
  addCopyCenterId       = '';
  addCopyIsCreating     = false;
  addCopyError          = '';
  addCopyGeneratedSrNos: number[] = [];
  addCopySelectedCenter: any = null;

  centers:        any[] = [];
  centersLoading        = false;

  constructor(
    private api:        ApiService,
    private labelPrint: LabelPrintService,
    private pageTitle:  PageTitleService,
    private router:     Router,
  ) {}

  ngOnInit(): void {
    this.pageTitle.set('Add Book', 'Add new books to the library catalogue');
  }

  onBookSaved(event: BookSavedEvent): void {
    this.booksAddedCount++;
    this.lastAddedBook = event.bookName;
    this.openAddCopyModal({ _id: event.result.id, bookId: event.result.bookId, bookName: event.bookName });
  }

  goToDashboard(): void { this.router.navigateByUrl('/dashboard'); }

  // ── Add Copy modal ───────────────────────────────────────────────────────────

  openAddCopyModal(book: any): void {
    this.addCopyBook          = book;
    this.addCopyStep          = 'form';
    this.addCopyCopies        = 1;
    this.addCopyCenterId      = '';
    this.addCopyError         = '';
    this.addCopyGeneratedSrNos = [];
    this.addCopySelectedCenter = null;
    this.showAddCopyModal     = true;
    if (!this.centers.length && !this.centersLoading) {
      this.centersLoading = true;
      this.api.getCenters().subscribe({
        next: (data) => { this.centers = data || []; this.centersLoading = false; },
        error: () => { this.centersLoading = false; },
      });
    }
  }

  closeAddCopyModal(): void {
    this.showAddCopyModal = false;
    this.addCopyBook      = null;
  }

  createCopies(): void {
    const copies = Number(this.addCopyCopies);
    if (!copies || copies < 1 || copies > 200) { this.addCopyError = 'Enter between 1 and 200 copies.'; return; }
    if (!this.addCopyCenterId) { this.addCopyError = 'Please select a center.'; return; }
    this.addCopyIsCreating    = true;
    this.addCopyError         = '';
    this.addCopySelectedCenter = this.centers.find(c => c._id === this.addCopyCenterId) ?? null;
    this.api.addCopies({ id: this.addCopyBook._id, numberOfCopies: copies, centerId: this.addCopyCenterId }).subscribe({
      next: (result: any) => {
        this.addCopyGeneratedSrNos = (result.generatedSrNos || []).map((n: any) => Number(n));
        this.addCopyStep           = 'result';
        this.addCopyIsCreating     = false;
      },
      error: (err: any) => {
        this.addCopyError      = err?.message || 'Failed to create copies.';
        this.addCopyIsCreating = false;
      },
    });
  }

  padSrNo(n: number): string { return String(n).padStart(6, '0'); }

  printAndClose(): void {
    if (this.addCopyGeneratedSrNos.length) {
      this._doPrint(this.addCopyBook, this.addCopyGeneratedSrNos);
    }
    this.closeAddCopyModal();
  }

  private async _doPrint(book: any, srNos: number[]): Promise<void> {
    if (!srNos.length) return;
    const clientName = await this.labelPrint.resolveClientName();
    this.labelPrint.print(book?.bookName || '', srNos, clientName);
  }
}
